import { Inline } from '@syl-editor/core-utilities';
import { toRgba } from '@syl-editor/lib/dist/lib/utils/hex';

const colorReg = /^\s*(rgba\([^)]+\)|rgb\([^)]+\)|#[\d|a-f]{3,6})|\w*/i;
function getBgAttrs(style: string): any {
  const colorMatch = style.match(colorReg);
  if (!colorMatch) return;
  const background = toRgba(colorMatch[0]);
  if (background) {
    return {
      color: background,
    };
  }
  return false;
}

export default class DIYBackground extends Inline<any> {
  public name = 'diyBackground';

  public tagName = () => 'span';

  public attrs = {
    color: {
      default: null,
    },
  };

  public parseDOM = [
    {
      style: 'background',
      getAttrs: getBgAttrs,
    },
    {
      style: 'background-color',
      getAttrs: getBgAttrs,
    },
  ];

  public toDOM = (node: any) => [
    'span',
    { style: `background-color: ${node.attrs.color}` },
    0,
  ];
}
